import React from "react";
import Accordion from 'react-bootstrap/Accordion';
export default function PhysicalFaq({data}) {
  return (
    <>
      <section className="physical-faq-area">
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-lg-5 col-md-6 order-1 order-md-0">
              <h3 className="heading">Our FAQ’S</h3>
              <div className="physical-faq-accor">
                <Accordion defaultActiveKey="0">
                  {data?.faqs?.map((item, index) => (
                    <Accordion.Item key={index} eventKey={`${index}`}>
                      <Accordion.Header>{item?.question}</Accordion.Header>
                      <Accordion.Body>{item?.answer}</Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 order-0 order-md-1">
              <img src={data?.image} alt="Faq Image" />
            </div>
          </div>
        </div>
      </section>
    </>
  )
}